var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-avatar',{staticStyle:{"border":"3px solid rgba(2, 4, 7, 1)"},attrs:{"size":_vm.size,"color":_vm.employeeNameColor}},[_c('v-img',{attrs:{"contain":"","src":_vm.employee.img['main'][0].picture.thumbnail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }